import type { ComponentProps } from 'react';
import { asStayEntityFixture, asWidgetProps } from 'Src/types/widget-helpers';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { isArchived as isPast } from 'Utils/ple-utils/bookingUtils';
import { ProductBlockHeader } from 'Components/widgets/product-block-header/ProductBlockHeader';
import { DurationTravelDetails } from './duration/DurationTravelDetails';
import { ParticipantsTravelDetails } from './participants/ParticipantsTravelDetails';
import { TransportTravelDetails } from './transport/TransportTravelDetails';
type Props = {
  bookingStatus: BookingStatus;
  className?: string;
  isBookingCart?: boolean;
  stay: StayEntity;
};

const propsForTransportTravelDetails = (
  bookingStatus: BookingStatus,
  stay: StayEntity = asStayEntityFixture({}),
) => ({
  arrivalCity: stay.transport?.toCityCode || '',
  bookingStatus: bookingStatus,
  departureCity: stay.transport?.fromCityCode || '',
  isJoyview: stay.product?.isJoyview,
  returnDate: stay.dates.endDate || '',
  transportType: stay.transport?.type || '',
  vendor: {
    isSoldByClubMed: stay.booking.vendor.isSoldByClubmed,
    name: stay.booking.vendor.name,
    phoneNumber: stay.booking.vendor.phoneNumber,
  },
});

export const TravelDetails = ({ bookingStatus, className, stay }: Props) => {
  const isJoyview = stay?.product?.isJoyview;
  const isArchived = isPast(bookingStatus);
  return stay ? (
    <div className={classnames('flex flex-col justify-between gap-20 sm:flex-row', className)}>
      <ProductBlockHeader
        {...asWidgetProps<ComponentProps<typeof ProductBlockHeader>>({
          product: stay.product,
          theme: 'cart',
        })}
      />
      <DurationTravelDetails
        {...asWidgetProps<ComponentProps<typeof DurationTravelDetails>>({
          className: 'flex-1',
          departureDate: stay.dates.startDate || '',
          returnDate: stay.dates.endDate || '',
        })}
      />

      {!isArchived && (
        <ParticipantsTravelDetails
          {...asWidgetProps<ComponentProps<typeof ParticipantsTravelDetails>>({
            adultsCounter: stay.participants.adultsCount || 0,
            childrenCounter: stay.participants.childrenCount || 0,
            className: 'flex-1',
          })}
        />
      )}
      {!isJoyview && (
        <TransportTravelDetails
          {...asWidgetProps<ComponentProps<typeof TransportTravelDetails>>({
            className: 'flex-1',
            ...propsForTransportTravelDetails(bookingStatus, stay),
          })}
        />
      )}
    </div>
  ) : null;
};
